import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ApiService } from '../../services/api.service';
import { WorkstationRoleType } from '../../models/client-management.model';

@Component({
  selector: 'app-role-types-management',
  imports: [CommonModule, FormsModule],
  templateUrl: './role-types-management.component.html',
  styleUrl: './role-types-management.component.scss'
})
export class RoleTypesManagementComponent implements OnInit {
  roleTypes: WorkstationRoleType[] = [];
  trackedDatabases: string[] = [];
  filterDatabase = '';
  loading = false;
  error: string | null = null;

  showModal = false;
  isEditMode = false;
  currentRoleType: Partial<WorkstationRoleType> = {};

  showRequestModal = false;
  requestDescription = '';
  requestingRoleType: WorkstationRoleType | null = null;

  constructor(private apiService: ApiService) {}

  ngOnInit(): void {
    this.apiService.getTrackedDatabases().subscribe({
      next: (dbs) => { this.trackedDatabases = dbs; },
      error: () => {}
    });
    this.loadRoleTypes();
  }

  loadRoleTypes(): void {
    this.loading = true;
    this.error = null;

    this.apiService.getRoleTypes(this.filterDatabase || undefined).subscribe({
      next: (data) => {
        this.roleTypes = data;
        this.loading = false;
      },
      error: (err) => {
        this.error = 'Failed to load role types: ' + (err.error?.error || err.message);
        this.loading = false;
      }
    });
  }

  onFilterChange(): void {
    this.loadRoleTypes();
  }

  openCreateModal(): void {
    this.isEditMode = false;
    this.currentRoleType = {
      roleTypeName: '',
      description: '',
      databaseName: undefined,
      isActive: true
    };
    this.showModal = true;
  }

  openEditModal(roleType: WorkstationRoleType): void {
    this.isEditMode = true;
    this.currentRoleType = { ...roleType };
    this.showModal = true;
  }

  closeModal(): void {
    this.showModal = false;
    this.currentRoleType = {};
  }

  saveRoleType(): void {
    if (!this.currentRoleType.roleTypeName?.trim()) {
      alert('Role type name is required');
      return;
    }

    if (!this.currentRoleType.databaseName) {
      alert('Database is required');
      return;
    }

    this.loading = true;

    if (this.isEditMode && this.currentRoleType.roleTypeID) {
      this.apiService.updateRoleType(this.currentRoleType.roleTypeID, this.currentRoleType as WorkstationRoleType).subscribe({
        next: () => {
          this.loadRoleTypes();
          this.closeModal();
        },
        error: (err) => {
          alert('Failed to update role type: ' + (err.error?.error || err.message));
          this.loading = false;
        }
      });
    } else {
      this.apiService.createRoleType(this.currentRoleType).subscribe({
        next: () => {
          this.loadRoleTypes();
          this.closeModal();
        },
        error: (err) => {
          alert('Failed to create role type: ' + (err.error?.error || err.message));
          this.loading = false;
        }
      });
    }
  }

  openRequestModal(roleType: WorkstationRoleType): void {
    this.requestingRoleType = roleType;
    this.requestDescription = '';
    this.showRequestModal = true;
  }

  closeRequestModal(): void {
    this.showRequestModal = false;
    this.requestingRoleType = null;
  }

  submitRequest(): void {
    if (!this.requestingRoleType) return;
    this.apiService.requestRoleTypeArtifact(this.requestingRoleType.roleTypeID, this.requestDescription || undefined).subscribe({
      next: () => {
        alert(`Artifact request submitted for "${this.requestingRoleType!.roleTypeName}"`);
        this.closeRequestModal();
      },
      error: (err) => {
        alert('Failed to submit request: ' + (err.error?.error || err.message));
      }
    });
  }

  deleteRoleType(roleType: WorkstationRoleType): void {
    if (!confirm(`Are you sure you want to delete role type "${roleType.roleTypeName}"?`)) {
      return;
    }

    this.loading = true;
    this.apiService.deleteRoleType(roleType.roleTypeID).subscribe({
      next: () => {
        this.loadRoleTypes();
      },
      error: (err) => {
        alert('Failed to delete role type: ' + (err.error?.error || err.message));
        this.loading = false;
      }
    });
  }
}
